export default __webpack_public_path__ + "static/media/18_tag_paid-massage-service.014750f3.svg";